/** خريطة المسارات — الشاشات الثماني المعتمدة. */

import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AppShell } from './AppShell';
import HomeRoute from '@/routes/HomeRoute';
import EvaluateRoute from '@/routes/EvaluateRoute';
import ResultRoute from '@/routes/ResultRoute';
import MapRoute from '@/routes/MapRoute';
import DistrictRoute from '@/routes/DistrictRoute';
import OpportunitiesRoute from '@/routes/OpportunitiesRoute';
import WatchlistRoute from '@/routes/WatchlistRoute';
import ReportsRoute from '@/routes/ReportsRoute';
import AuthRoute from '@/routes/AuthRoute';
import AccountRoute from '@/routes/AccountRoute';
import GuideRoute from '@/routes/GuideRoute';
import TermsRoute from '@/routes/legal/TermsRoute';
import PrivacyRoute from '@/routes/legal/PrivacyRoute';
import DisclaimerRoute from '@/routes/legal/DisclaimerRoute';
import { ProtectedRoute } from './ProtectedRoute';

export const ROUTES: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <HomeRoute /> },
      { path: 'evaluate', element: <EvaluateRoute /> },
      { path: 'result', element: <ResultRoute /> },
      { path: 'map', element: <MapRoute /> },
      { path: 'district/:districtId', element: <DistrictRoute /> },
      { path: 'opportunities', element: <OpportunitiesRoute /> },
      {
        path: 'watchlist',
        element: (
          <ProtectedRoute>
            <WatchlistRoute />
          </ProtectedRoute>
        ),
      },
      {
        path: 'reports',
        element: (
          <ProtectedRoute>
            <ReportsRoute />
          </ProtectedRoute>
        ),
      },
      { path: 'guide', element: <GuideRoute /> },
      { path: 'terms', element: <TermsRoute /> },
      { path: 'privacy', element: <PrivacyRoute /> },
      { path: 'disclaimer', element: <DisclaimerRoute /> },
      { path: 'auth', element: <AuthRoute /> },
      {
        path: 'account',
        element: (
          <ProtectedRoute>
            <AccountRoute />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export const router = createBrowserRouter(ROUTES);
